import {
  PublicDemandFormDetails,
  SendPublicDemandFormPayload,
  SendPublicDemandFormResponse,
} from '@features/public-demand-form/utils/models/public-demand-form.model';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { HttpError } from '@shared/utils/models/http.model';

export const PublicDemandFormActions = createActionGroup({
  source: 'Public Demand Form',
  events: {
    'Validate Demand Form': props<{ userId: number }>(),
    'Validate Demand Form Success': props<{ data: PublicDemandFormDetails }>(),
    'Validate Demand Form Failure': props<{ error: HttpError }>(),
    'Send Demand Form': props<{ payload: SendPublicDemandFormPayload }>(),
    'Send Demand Form Success': props<{ data: SendPublicDemandFormResponse }>(),
    'Send Demand Form Failure': props<{ error: HttpError }>(),
  },
});

export const PublicDemandFormResetActions = createActionGroup({
  source: 'Public Demand Form',
  events: {
    'Cancel Public Demand Form Actions': emptyProps(),
    'Cancel Public Demand Form Actions Success': emptyProps(),
    'Reset Public Demand Form': emptyProps(),
  },
});
